export default {
  pictograms: [],
  pictograms_main: [],
  filter: {
    product_id: null,
    company_id: null,
    page: 1,
    per_page: 10,
    sortBy: 'id',
    sort: 'DESC',
  },
}



